<template>

  <div>
      <v-app-bar app elevation="0" color="white">
        <v-btn icon text>
          <v-btn icon text @click.native="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-btn>
        <v-toolbar-title class="title"></v-toolbar-title>
        <v-spacer></v-spacer>
          <v-btn v-if="detail.link"
            text color="primary"
            small
            outlined
            :href="detail.link"
            target="blank"
          >
            <v-icon left>mdi-link</v-icon> link
          </v-btn>
          <v-btn v-if="detail.doi"
            text
            outlined
            small
            :href="detail.doi"
            target="blank"
            class="ml-2"
          >
            <v-icon left>mdi-link</v-icon> doi
          </v-btn>
      </v-app-bar>

      <v-container fluid class="ma-0 pa-0">

        <v-alert class="ma-4" type="error" v-if="error">Gagal memuat data...</v-alert>

        <template v-if="loading">
            <v-sheet
          >
            <v-skeleton-loader
              class="mx-auto"
              type="card"
              height="600"
            ></v-skeleton-loader>
          </v-sheet>
        </template>
        <template v-else>
          <v-card flat>
            <v-card-text>
              <v-chip small label color="primary" class="overline" v-text="detail.category"></v-chip>
            </v-card-text>
            <v-card-title class="headline font-weight-bold" v-text="detail.title"></v-card-title>
            <v-card-text>
              <p class="text--secondary body-2" v-text="detail.author"></p>
              <p class="body-1 text-justify">{{ detail.abstract }}</p>
            </v-card-text>
          </v-card>
        </template>

        <!-- <v-divider></v-divider>

        <v-list three-line flat>
          <v-subheader>Similiar Jurnal</v-subheader>

          <template v-if="recentsLoader">
            <v-sheet>
              <v-skeleton-loader
                v-for="i in 6"
                :key="'loader-'+i"
                class="mx-auto"
                type="list-item-two-line"

              ></v-skeleton-loader>
            </v-sheet>
          </template>
          <template v-else>
            <template v-for="(item,i) in recents">

                  <v-list-item
                    :key="'item-'+i"
                    link
                    :to="'/jurnal/show/'+item.id"
                  >
                      <v-list-item-content>
                          <v-list-item-subtitle class="mb-1"><v-chip x-small label outlined color="success" class="overline">Social</v-chip></v-list-item-subtitle>
                          <v-list-item-title v-text="item.title"></v-list-item-title>
                          <v-list-item-subtitle>J.K Rowling</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn icon>
                            <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-list-item-action>
                  </v-list-item>
                  <v-divider :key="'item'+i"></v-divider>

            </template>
          </template>

        </v-list> -->
      </v-container>

  </div>
</template>

<script>
export default {
  name: 'Jurnal-single',
  inject: ['theme'],

  data: () => ({
    error: null,

    loading: false,
    detail: null,

    recents: [],
    recentsLoader: false
  }),

  '$route.params.id': {
    handler (id) {
      this.fetchDetail()
      this.fetchSimiliar()
    },
    immediate: true
  },

  created () {
    this.fetchDetail()
    this.fetchSimiliar()
  },

  methods: {
    async fetchSimiliar () {
      this.recentsLoader = true
      var url = 'journal/recents/' + this.$route.params.id
      const response = await this.$axios.get(url)
      this.recents = response.data.results
      this.recentsLoader = false
    },
    fetchDetail () {
      this.error = null
      this.loading = true
      var url = 'journal/show/' + this.$route.params.id
      this.$axios
        .get(url)
        .then(response => { this.detail = response.data.data })
        .catch(error => this.error = error)
        .finally(() => this.loading = false)
    }
  }

}
</script>
